export default __webpack_public_path__ + "static/media/img_19.7e77e6e1.JPG";